/* ============================================================
   Maison Broderie — global.js
   Interactions de base du thème vierge.
   ============================================================ */
(function () {
  'use strict';

  // --- Galerie produit : clic sur miniature -> image principale ---
  document.addEventListener('click', function (event) {
    var thumb = event.target.closest('.product__thumbnails img');
    if (!thumb) return;
    var main = document.querySelector('.product__image');
    if (main) {
      main.src = thumb.src.replace('width=200', 'width=1200');
      main.alt = thumb.alt;
    }
  });

  // --- Ajout au panier en AJAX (tous les formulaires produit) ---
  // Un POST classique vers /cart/add redirige toujours vers /cart. On l'intercepte : ajout en
  // AJAX, puis ouverture du tiroir panier (window.MBCart, défini dans accueil.js). Si l'ajout
  // échoue (rupture, réseau), on retombe sur l'envoi natif du formulaire.
  document.addEventListener('submit', function (event) {
    var form = event.target;
    if (event.defaultPrevented || !form.matches('form[action*="/cart/add"]')) return;
    event.preventDefault();
    if (form.dataset.mbBusy) return;
    form.dataset.mbBusy = '1';

    var button = event.submitter;
    if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
    var added = false;

    fetch('/cart/add.js', { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) })
      .then(function (response) {
        if (!response.ok) throw new Error('ajout ' + response.status);
        added = true;
        if (!window.MBCart) throw new Error('tiroir indisponible');
        return window.MBCart.refreshAndOpen();
      })
      .catch(function () {
        // Ajout réussi mais tiroir indisponible : page panier. Ajout refusé : envoi natif
        // (Shopify affiche alors lui-même le message d'erreur).
        if (added) { window.location.href = '/cart'; } else { form.submit(); }
      })
      .then(function () {
        delete form.dataset.mbBusy;
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      });
  });
})();
